// src/store/slices/resetSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isResetting: false,
  resetHistory: [],
  lastReset: null,
  resetErrors: [],
  registeredComponents: [],
};

const resetSlice = createSlice({
  name: 'reset',
  initialState,
  reducers: {
    startReset: (state) => {
      state.isResetting = true;
      state.resetErrors = [];
    },
    resetComplete: (state, action) => {
      state.isResetting = false;
      state.lastReset = new Date().toISOString();
      state.resetHistory.push({
        timestamp: new Date().toISOString(),
        contexts: action.payload?.contexts || [],
        success: true,
      });
      // Keep only last 50 resets
      if (state.resetHistory.length > 50) {
        state.resetHistory = state.resetHistory.slice(-50);
      }
    },
    resetFailed: (state, action) => {
      state.isResetting = false;
      state.resetErrors.push({
        timestamp: new Date().toISOString(),
        error: action.payload?.error || 'Unknown error',
        contexts: action.payload?.contexts || [],
      });
      // Keep only last 20 errors
      if (state.resetErrors.length > 20) {
        state.resetErrors = state.resetErrors.slice(-20);
      }
    },
    registerComponent: (state, action) => {
      const { componentId, resetFn } = action.payload;
      // Check if already registered
      const exists = state.registeredComponents.some(c => c.componentId === componentId);
      if (!exists) {
        state.registeredComponents.push({
          componentId,
          resetFn: resetFn.toString(), // Store function as string
          registeredAt: new Date().toISOString(),
        });
      }
    },
    unregisterComponent: (state, action) => {
      state.registeredComponents = state.registeredComponents.filter(
        c => c.componentId !== action.payload
      );
    },
    clearResetHistory: (state) => {
      state.resetHistory = [];
      state.resetErrors = [];
    },
    clearResetErrors: (state) => {
      state.resetErrors = [];
    },
  },
});

export const {
  startReset,
  resetComplete,
  resetFailed,
  registerComponent,
  unregisterComponent,
  clearResetHistory,
  clearResetErrors,
} = resetSlice.actions;

export default resetSlice.reducer;

// Selectors
export const selectIsResetting = (state) => state.reset.isResetting;
export const selectResetHistory = (state) => state.reset.resetHistory;
export const selectResetErrors = (state) => state.reset.resetErrors;
export const selectLastReset = (state) => state.reset.lastReset;
export const selectRegisteredComponents = (state) => state.reset.registeredComponents;